import { requireField } from './validators';

export default class SupportReview {
  constructor(data = {}) {
    requireField(data.title, 'supportReview.title');
    requireField(data.dueDate, 'supportReview.dueDate');

    this.id = data.id || `rev-${Math.random().toString(36).slice(2, 9)}`;
    this.title = data.title;
    this.dueDate = data.dueDate;
    this.assignedTo = data.assignedTo || '';
    this.status = data.status || 'open';
    this.notes = data.notes || '';
    this.createdBy = data.createdBy || 'System';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || this.createdAt;
  }

  toJSON() {
    return { ...this };
  }
}
